import axios from 'axios'
import React, { useEffect, useState, useMemo } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import styled from 'styled-components'

const ShopbyCategory = ({ categoryId, merchantSiteNavsearch }) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const { merchantid } = useParams();
  const [data, setData] = useState([])

  // Get first category id if prop is empty
  useEffect(() => {
    if (!categoryId || categoryId === "") {
      axios
        .get(`https://api.bakpoket.com/api/MerchantCategories?merchantId=${merchantid}&onlyActive=true`)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            setSelectedCategoryId(res.data[0].id);
          }
        })
        .catch((err) => console.log(err));
    } else {
      setSelectedCategoryId(categoryId); 
    }
  }, [merchantid, categoryId]);

  // Fetch products for selected category
  useEffect(() => {
    if (!selectedCategoryId) return;
    axios
      .get(
        `https://api.bakpoket.com/api/merchantpage/efq/products?merchantId=${merchantid}&categoryId=${selectedCategoryId}&approvedOnly=false&includeImages=true`
      )
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  }, [selectedCategoryId]);

  // Filtered data based on search
  const filteredData = useMemo(() => {
    if (!merchantSiteNavsearch || merchantSiteNavsearch.trim() === "") {
      return data;
    }
    return data.filter((ad) =>
      ad.productName?.toLowerCase().includes(merchantSiteNavsearch.toLowerCase())
    );
  }, [data, merchantSiteNavsearch]);

  // Dummy fallback array
  const arraydata = [
    { id:1, imageMediumBase64:"/images/image-600x800.jpg", price:"0.00", productName:"Product Name" },
    { id:2, imageMediumBase64:"/images/image-600x800.jpg", price:"0.00", productName:"Product Name" },
    { id:3, imageMediumBase64:"/images/image-600x800.jpg", price:"0.00", productName:"Product Name" },
    { id:4, imageMediumBase64:"/images/image-600x800.jpg", price:"0.00", productName:"Product Name" },
  ]

  return (
    <Wrapper>
      <div className="container">
        <div className="row my-3">
          {data && data.length > 0 ? (
            filteredData && filteredData.length > 0 ? (
              // ✅ API data + search matched
              <AdGrid>
                {filteredData.map((ad) => (
                  <AdCard key={`ad-${ad.id}`}>
                    <div>
                      {/* <img
                        src={`data:image/jpeg;base64,${ad.imageMediumBase64}`}
                        alt={ad.productName}
                        style={{ width: '100%' }}
                      /> */}
                      <img
                        src={`data:image/jpeg;base64,${ad?.imageMediumBase64}`}
                        className="img-fluid"
                        style={{
                          width: "100%",
                          aspectRatio: "600 / 800",
                          objectFit: "cover"
                        }}
                      />

                      <h6 className="product-name my-2 fw-bold">{ad.productName}</h6>
                      <h5 className="mb-2">Rs. {ad.price}</h5>
                      <NavLink to={`/payment/${ad.price}`}>
                        <button className="btn rounded w-100 mx-auto fs-5">Buy Now</button>
                      </NavLink>
                    </div>
                  </AdCard>
                ))}
              </AdGrid>
            ) : (
              // ❌ API data but no search matches
              <Para>Item not found</Para>
            )
          ) : (
            // 🟡 No API data → fallback to dummy array
            <AdGrid>
              {arraydata.map((ad) => (
                <AdCard key={`ad-${ad.id}`}>
                  <div>
                    <img src={ad.imageMediumBase64} alt={ad.productName} style={{ width: '100%' }} />
                    <h6 className="my-2 fw-bold">{ad.productName}</h6>
                    <h5 className="mb-2">Rs. {ad.price}</h5>
                    <button className="btn rounded w-100 mx-auto fs-5">Buy Now</button>
                  </div>
                </AdCard>
              ))}
            </AdGrid>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

export default ShopbyCategory

// ---------- Styled Components ----------
const Wrapper = styled.section`
  h4{
    margin-left: 30px;
  }

  @media(max-width:576px){
    h4{
      margin-left: 0px;
    }
  }
`

const AdGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }
`;

const AdCard = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  padding: 5px;

  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }

  .product-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;   /* show max 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 3em;         
    line-height: 1.5em;      
  }
`;

const Para = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #666;
`;
